module.exports = __webpack_public_path__ + "static/media/040.0f85c398.png";